export { default } from './Chip'
